/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useState, useEffect } from "react";

const ORDER_PARAMS = {
  "name-asc":   { orderField: "name",  orderDirection: "ASC" },
  "name-desc":  { orderField: "name",  orderDirection: "DESC" },
  "price-asc":  { orderField: "price", orderDirection: "ASC" },
  "price-desc": { orderField: "price", orderDirection: "DESC" },
};

const SORT_FNS = {
  "name-asc":   (a, b) => a.name.localeCompare(b.name),
  "name-desc":  (a, b) => b.name.localeCompare(a.name),
  "price-asc":  (a, b) => a.price - b.price,
  "price-desc": (a, b) => b.price - a.price,
};

export const useProductsSearchSort = () => {
  const [searchValue, setSearchValue] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [sortBy, setSortBy] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedSearch(searchValue), 300);
    return () => clearTimeout(timer);
  }, [searchValue]);

  const { orderField, orderDirection } = ORDER_PARAMS[sortBy] || {};
  const sortFn = SORT_FNS[sortBy] || null;

  return { searchValue, debouncedSearch, sortBy, orderField, orderDirection, sortFn, setSearchValue, setSortBy };
};